import { format } from 'sql-formatter';
import type { SqlLanguage } from 'sql-formatter';

/**
 * 格式化 SQL 文本；解析失败时回退为原始字符串。
 */
export const formatPreviewSql = (
  rawSql: string,
  language: SqlLanguage = 'mysql',
): string => {

  try {
    return format(rawSql, { language });
  } catch (e) {
    console.error('预览 SQL 解析失败', { e, sql: rawSql, language });
    return rawSql;
  }
};
